// The version identifier for the currently-published Terms of Service.
//
// Must be kept in sync with `CURRENT_TOS_VERSION` in
// `backend/src/model/user_consent_model.ts`. Both sides receive the same string
// so the value persisted server-side reflects exactly what the user saw on
// screen at acceptance time.
//
// Bump this value whenever the TOS document changes; existing users whose
// latest accepted version is older than this should be re-prompted on next
// login.
export const CURRENT_TOS_VERSION = "2026-10-01";

// Public path to the canonical, legally-vetted Terms of Service PDF (served from
// the frontend `public/` folder). This is the source of truth; the in-app modal
// renders a formatted transcription of it for readability.
export const TOS_PDF_URL = "/term_of_service/Creatorverse_Platform_Terms_2026-10-01.pdf";
